import { render } from "./DeleteCategoryModalComponent.vue?vue&type=template&id=da366080&scoped=true"
import script from "./DeleteCategoryModalComponent.vue?vue&type=script&lang=js"
export * from "./DeleteCategoryModalComponent.vue?vue&type=script&lang=js"

import "./DeleteCategoryModalComponent.vue?vue&type=style&index=0&id=da366080&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-da366080"]])

export default __exports__